import { render } from "./AdminTopbar.vue?vue&type=template&id=1a2a1a5c&scoped=true"
import script from "./AdminTopbar.vue?vue&type=script&lang=js"
export * from "./AdminTopbar.vue?vue&type=script&lang=js"

import "./AdminTopbar.vue?vue&type=style&index=0&id=1a2a1a5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a2a1a5c"]])

export default __exports__